import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import { formValueSelector } from 'redux-form';
import purchaseTypeSelector from 'redux_store/selectors/dictionary/purchaseType';
import cardInfoSelector from 'redux_store/selectors/tenderCard/info';
import currencySelector from 'redux_store/selectors/tenderCard/currency';
import historySelector from 'redux_store/selectors/tenderCard/history';
import { editAccess } from 'utils/access';
import { userImg } from 'theme/icon';

const statusPointer = state => state.dictionary.status;
const allUsersPointer = state => state.dictionary.zoneUser;
const usersPointer = state => state.dictionary.user;
const regionPointer = state => state.dictionary.region;
const currencyPointer = state => state.dictionary.currency;
const placingWayPointer = state => state.dictionary.placingWay;
const logTypePointer = state => state.dictionary.logType;
const userDependencyPointer = state => state.dictionary.userDependency;
const cardPointer = state => state.tenderCard;
const loginPointer = state => state.login;
const deleteStatusPointer = state => state.adminZone.tenderCleanStatus;
const globalVariblePointer = state => state.global.varibles;
const userMarkersPointer = state => state.dictionary.marker;

const fvselector = formValueSelector('cardHistoryFilter');
const isCreateViewPointer = state => fvselector(state, 'isCreateView');
const isOwnerViewPointer = state => fvselector(state, 'isOwnerView');
const isStatusViewPointer = state => fvselector(state, 'isStatusView');
const isCommentViewPointer = state => fvselector(state, 'isCommentView');

const cardDocumentsFilterSelector = formValueSelector('cardDocumentsFilter');
const cardDocumentsFilterPointer = state => cardDocumentsFilterSelector(state, 'name');

const locationPointer = state => state.router.location.pathname;

const CARD_DOCUMENT_FILTER_LENGTH = 3;

export default createSelector(
  [
    statusPointer,
    allUsersPointer,
    currencyPointer,
    placingWayPointer,
    purchaseTypeSelector,
    regionPointer,
    cardPointer,
    logTypePointer,
    isCreateViewPointer,
    isOwnerViewPointer,
    isStatusViewPointer,
    isCommentViewPointer,
    locationPointer,
    loginPointer,
    userDependencyPointer,
    cardDocumentsFilterPointer,
    cardInfoSelector,
    globalVariblePointer,
    currencySelector,
    historySelector,
    usersPointer,
    userMarkersPointer,
    deleteStatusPointer,
  ],
  (
    status,
    allUsers,
    currency,
    placingWay,
    purchaseType,
    region,
    tenderCard,
    logType,
    isCreateView,
    isOwnerView,
    isStatusView,
    isCommentView,
    location,
    login,
    userDependency,
    cardDocumentsFilter,
    cardInfo,
    globalVarible,
    curren,
    history,
    users,
    userMarkers,
    deleteStatus,
  ) => {
    const { access, id: currentUserId, zoneId, roleId } = login;
    const {
      eventsSystem,
      commentView,
      commentAdd,
      documentsView,
      documentsEdit,
      blockAccess,
      participantsView,
      attributeEdit,
      attributeView,
      tenderEdit,
      tenderDelete,
      victoryChance,
      markerEdit,
    } = access;
    const { info } = tenderCard;

    const pw = info.placing_way && placingWay.find(x => x.id === info.placing_way.id);

    const orgRegion = info.region && region.find(e => e.code === info.region.code);
    const userStatus = status.find(s => s.id === info.statusId);

    const deliveryRegion =
      info.delivery_place && info.delivery_place_region && region.find(e => e.id === info.delivery_place_region);
    const pathParts = location.split('/');
    const tab = pathParts[pathParts.length - 1];
    const isEventsView = editAccess(eventsSystem, currentUserId, info.ownerId, userDependency);
    const isCommentAdd = editAccess(commentAdd, currentUserId, info.ownerId, userDependency);
    const isDocumentsView = editAccess(documentsView, currentUserId, info.ownerId, userDependency);
    const isDocumentsEdit = editAccess(documentsEdit, currentUserId, info.ownerId, userDependency);
    const isAttributeEdit = editAccess(attributeEdit, currentUserId, info.ownerId, userDependency);
    const isAttributeView = editAccess(attributeView, currentUserId, info.ownerId, userDependency);
    const isTenderEdit = editAccess(tenderEdit, currentUserId, info.ownerId, userDependency);
    const isTenderDelete = editAccess(tenderDelete, currentUserId, info.ownerId, userDependency);
    const isCommentViewAccess = editAccess(commentView, currentUserId, info.ownerId, userDependency);

    const isParticipantsView = editAccess(participantsView, currentUserId, info.ownerId, userDependency);
    // const isParticipantsView = editAccess(participantsView, currentUserId, tenderCard.ownerId, userDependency);

    let isDownloadAllInner = 0;
    (tenderCard.documents.inner || [])
      .filter(d => d.size)
      .forEach(e => {
        isDownloadAllInner += +e.size;
        return true;
      });
    let isDownloadAllPro = 0;
    (tenderCard.documents.pro || [])
      .filter(d => d.size)
      .forEach(e => {
        isDownloadAllPro += +e.size;
        return true;
      });
    const subscribe = {
      subscribe: tenderCard.subscribe.map(s => {
        const u = allUsers.find(x => x.id === s);
        return {
          id: u.id,
          name: u.name,
          photo: u.photo ? `${globalVarible.AUTH_URL}/images/${u.photo}` : userImg,
          isAccess: tenderCard.userAccess.find(ua => ua === s),
        };
      }),
      other: users
        .filter(x => tenderCard.subscribe.indexOf(x.id) === -1)
        .map(u => ({
          id: u.id,
          name: u.name,
          photo: u.photo ? `${globalVarible.AUTH_URL}/images/${u.photo}` : userImg,
        })),
      isSubscribe: tenderCard.subscribe.find(x => x === currentUserId) !== undefined,
    };
    const chancePlacingWay = [49, 53, 51, 45, 40];
    const chanceTenderType = [5, 4];

    let purchaseTypeName = info.type && info.type.name;
    if (info.reportId === 42) {
      const type = purchaseType.find(el => el.id === info.type.id + 100);
      if (type) {
        purchaseTypeName = type.name;
      }
    }

    const proDocs =
      cardDocumentsFilter && cardDocumentsFilter.length >= CARD_DOCUMENT_FILTER_LENGTH
        ? tenderCard.documents.pro.filter(d => d.name.toLowerCase().indexOf(cardDocumentsFilter.toLowerCase()) !== -1)
        : tenderCard.documents.pro;

    // PRODOC-870
    proDocs.forEach(el => {
      if (el.link.match('zakupki.gov.ru')) {
        el.link = el.link.replace('http://', 'https://');
      }
    });

    const tenderCardDocuments = {
      inner:
        cardDocumentsFilter && cardDocumentsFilter.length >= CARD_DOCUMENT_FILTER_LENGTH
          ? tenderCard.documents.inner.filter(
              d => d.name.toLowerCase().indexOf(cardDocumentsFilter.toLowerCase()) !== -1,
            )
          : tenderCard.documents.inner,
      pro: proDocs,
    };

    return {
      tenderData: {
        ...info,
        ...history,
        subscribe,
        lotId: info.id,
        price: info.price,
        subject: info.subject ? info.subject : info.purchase_subject,
        purchaseSubject: info.purchase_subject,
        currency: curren,
        contractPrice: info.contract_sum,
        currencyContractPrice: currency.find(el => el.uid === info.contract_currency || el.id === 0).symbol,
        subStatus: userStatus && userStatus.parentId ? userStatus : null,
        status: userStatus && userStatus.parentId ? status.find(s => s.id === userStatus.parentId) : userStatus,
        user: allUsers.find(x => x.id === info.ownerId),
        startDate: info.start_date ? dayjs.utc(info.start_date) : null,
        isStartDateCalculate: info.is_start_days_calculate,
        isEndDateCalculate: info.is_last_days_calculate,
        endDate: info.end_date ? dayjs.utc(info.end_date) : null,
        auctionDate: info.holding_date ? dayjs.utc(info.holding_date) : null,
        insertDate: info.insertDate ? dayjs.utc(info.insertDate) : null,
        placingWay: pw ? pw.name : '',
        purchaseType: { name: purchaseTypeName },
        isCustomTender: info.isCustomTender,
        victoryChanceSource: victoryChance.source,
        deliveryPlace: info.delivery_place
          ? {
              place: info.delivery_place,
              ...deliveryRegion,
            }
          : null,
        organizer: info.organizer
          ? {
              ...info.organizer,
              region: orgRegion || {},
            }
          : null,
        customers:
          info.customers && info.customers.length > 0
            ? info.customers.map(e => {
                const regionData = region.find(el => el.code === e.region.code) || {};
                return {
                  ...e,
                  region: { ...e.region, ...regionData },
                  fullName: e.full_name,
                  shortName: e.short_name,
                  deliveryPlace:
                    e.delivery_place &&
                    e.delivery_place.map(d => ({ ...d, ...region.find(r => r.id === d.region_id) })),
                  contractAmount: e.contract_amount,
                  contractCurrency: curren.symbol,
                  appAmount: e.app_amount,
                  appCurrency: curren.symbol,
                };
              })
            : null,
        customerCount: info.customer_count,
        productsDelivery:
          info.product_delivery && info.product_delivery.length > 0
            ? info.product_delivery.map(e => {
                const productsDeliveryRegion = e.region_id && region.find(r => r.id === e.region_id);
                return {
                  deliveryPlace: [{ ...e, ...productsDeliveryRegion }],
                };
              })
            : null,
        tradePlatform: info.trade_platform,
        isSMP: info.smp || (info.restrictions && info.restrictions.findIndex(e => e.id === 1) > -1),
        // pic: tenderCard.image,
        pic: info.image,
        notificationNumber: info.notification_number,
        tab,
        documents: tenderCardDocuments,
        access: {
          commentView: isCommentViewAccess,
          commentAdd: isCommentAdd && (!info.isCustomTender || (info.isCustomTender && info.isActive)),
          eventsView: isEventsView,
          documentsView: isDocumentsView && blockAccess.isDocument,
          documentsEdit: isDocumentsEdit && (!info.isCustomTender || (info.isCustomTender && info.isActive)),
          downloadAllInnerDocuments:
            (tenderCard.documents.inner || []).length > 0 && isDownloadAllInner <= 100 * 1024 * 1024,
          downloadAllProDocuments:
            (tenderCard.documents.pro || []).length > 0 &&
            isDownloadAllPro <= 100 * 1024 * 1024 &&
            isDownloadAllPro > 0,
          participantsView:
            blockAccess.isParticipants &&
            isParticipantsView &&
            (!info.isCustomTender || (info.isCustomTender && info.isActive)),
          attributeEdit: isAttributeEdit,
          attributeView: isAttributeView && blockAccess.isAttribute,
          tenderEdit: info.isCustomTender && isTenderEdit && info.isActive,
          tenderDelete: info.isCustomTender && isTenderDelete && info.isActive,
          markerEdit,
        },
        userId: currentUserId,
        markerColor: info.markerID && userMarkers.length ? userMarkers.find(m => m.id === info.markerID).color : null,
        zoneId,
        roleId,
        appAmountCurrency: curren.symbol,
      },
      cardSelector: cardInfo,
      access: {
        isVictoryChance: victoryChance.active,
        isShowChanceData:
          info.type &&
          chanceTenderType.indexOf(info.type.id) !== -1 &&
          info.placing_way &&
          chancePlacingWay.indexOf(info.placing_way.id) === -1 &&
          !info.isCustomTender,
      },
      isInClean: deleteStatus.general || deleteStatus.clean,
      proURL: globalVarible.PRO_URL,
      markers: [...userMarkers.filter(el => el.listTypeId === 1)],
    };
  },
);
